module.exports = __webpack_public_path__ + "media/assets/profile-picture-e0ed0506aa80b9a2bd97a4b546450dc9.jpg";